import React from 'react';
import { EpisodeAsset } from '../../../../queries/ats/titles/types/asset';
import { DetailsErrorBoundary } from '../../details-error/details-error';
import { Episode, EpisodeSkeleton } from '../episode/episode';
import { DateBasedEpisodeList } from './date-based-episode-list';
import css from './episode-list.module.scss';

interface EpisodeListProps {
  episodes: EpisodeAsset[];
  order: 'chronological' | 'date';
}

/**
 * Renders a list of episodes for a given season.
 *
 * @param episodes The episodes to render.
 */
export function EpisodeList({ episodes, order }: EpisodeListProps) {
  if (order === 'date') {
    return <DateBasedEpisodeList episodes={episodes} />;
  }

  return (
    <section className={css.list}>
      {episodes.map((episode) => (
        <DetailsErrorBoundary key={episode.masterId} label="episode">
          <Episode key={episode.masterId} episode={episode} />
        </DetailsErrorBoundary>
      ))}
    </section>
  );
}
export function EpisodeListSkeleton() {
  return (
    <section className={css.list}>
      {Array.from({ length: 5 }).map((_, i) => (
        <EpisodeSkeleton key={i} />
      ))}
    </section>
  );
}
